/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../../store/store';
import Filters from '../../../../../table/new/filters/Filters';
import Presets from '../../../../../table/new/Presets';
import {getFilters} from './new/getFilters';
import {facebookStatisticsFilters} from './new/filtersConfigs';
import {facebookStatisticsGroups} from './new/groupsConfigs';
import TableWrapper from '../../../../../table/new/TableWrapper';
import Columns from '../../../../../table/new/Columns';
import {baseFields} from '../../../../../table/new/customizationTable';
import BlankSheet from '../../../../../table/new/BlankSheet';
import FullScreen from '../../../../../table/new/FullScreen';
import Refresh from '../../../../../table/new/Refresh';
import ResultsCount from '../../../../../table/new/ResultsCount';
import Search from '../../../../../table/new/SearchForTable';

import moment from 'moment';
import ButtonExelWithLoadOnClick from '../../../../../modules/ButtonExelWithLoadOnClick';
import AddTraffic from './AddTraffic';

const Bloggers = () => {
  const store = useStore();

  const [timeConfig, setTimeConfig] = useState({});
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);


  return (
    <PageWrapper
      setTimeConfigFromWrapper={setTimeConfig}
      firstTimeConfig={'all_time'}
      prevTimeConfig={prevTimeConfig}
      allowAllTimes
      breadcrumbs={[
        {title: 'PanelHunt', path: '', isActive: true},
        {isSeparator: true},
        {title: 'Influence', path: '', isActive: true},
        {isSeparator: true},
        {title: 'Блогеры', path: '/tracker/influence/bloggers', isActive: true},
      ]}
      title={'Блогеры'}
    >
      <TableWrapper
        branch={'inf'}
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Dashboard/Influence/Statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
          {filter: 'bayer_id', isFixed: true, options: []},
          {filter: 'offer_id', isFixed: true, options: []},
          {filter: 'link_id', isFixed: true, options: []},
        ]}
        defaultGroups={[
          {group: 'inf_traffic', isFixed: true},
          {group: 'inf_source', isFixed: true},
        ]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields.filter((item) => item.value !== 'clicks')}
        disabledByDefault={[
          'click2reg',
          'click2cpa',
          'lead2fd',
          'lead2cpa',
          'chat2reg',
          'reg2cpa',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={
            <>
              {store.roles.includes(6) ||
              store.roles.includes(19) ||
              store.roles.includes(13) ||
              store.roles.includes(32) ||
              store.roles.includes(38) ? (
                <></>
              ) : (
                <AddTraffic type={'influence'} />
              )}
              <Search />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Bloggers);
